import { render, staticRenderFns } from "./FuelEfficiencyChart.vue?vue&type=template&id=2f3a383f&scoped=true&"
import script from "./FuelEfficiencyChart.vue?vue&type=script&lang=js&"
export * from "./FuelEfficiencyChart.vue?vue&type=script&lang=js&"
import style0 from "./FuelEfficiencyChart.vue?vue&type=style&index=0&id=2f3a383f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a383f",
  null
  
)

export default component.exports